var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgBin(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 18.199,
    height: 22.399,
    viewBox: "0 0 18.199 22.399",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Icon_metro-bin",
    "data-name": "Icon metro-bin",
    d: "M5.9,8.928v14a1.4,1.4,0,0,0,1.4,1.4H19.9a1.4,1.4,0,0,0,1.4-1.4v-14H5.9Zm4.2,12.6H8.7v-9.8h1.4Zm2.8,0H11.5v-9.8h1.4Zm2.8,0H14.3v-9.8h1.4Zm2.8,0H17.1v-9.8h1.4Zm3.15-16.8H17.1V2.978a1.053,1.053,0,0,0-1.05-1.05h-4.9a1.053,1.053,0,0,0-1.05,1.05v1.75H5.549A1.053,1.053,0,0,0,4.5,5.778v1.75H22.7V5.778A1.053,1.053,0,0,0,21.648,4.728Zm-5.95,0H11.5V3.346h4.2V4.728Z",
    transform: "translate(-4.499 -1.928)",
    fill: "#5dadae"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBin);
export default __webpack_public_path__ + "static/media/bin.1ade0af71ac9f167c9a15d6a75169d22.svg";
export { ForwardRef as ReactComponent };